// extracted by mini-css-extract-plugin
export default {"screenxxs":"320px","screenxs":"576px","screensm":"768px","screenmd":"992px","screenlg":"1200px","screenml":"1366px","screenxlg":"1440px","screenxxlg":"1600px","screenxxxlg":"2500px"};